import { Link } from 'react-router-dom';
import { getOptimizedImageUrl } from '../lib/utils';

export default function Footer() {
  const logoUrl = getOptimizedImageUrl(
    'https://assets.auxodev.dk/assets/06c9940a-d5a6-4016-a4ca-e876b6f16b3e/34a78654-9cb6-4b5b-93fb-23a3c5578977.png',
    { width: 300, quality: 90 }
  );

  return (
    <footer className="bg-slate-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1: Info */}
          <div>
            <img
              src={logoUrl}
              alt="CM Skruefundament ApS – Bæredygtige skruefundamenter og jordskruer til byggeri"
              title="CM Skruefundament ApS"
              className="h-auto w-auto mb-6 brightness-0 invert max-w-[220px] hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
            <p className="text-slate-400 max-w-xs leading-relaxed text-sm">
              Professionelle skruefundamenter til alle typer byggeri. Vi leverer hurtige, 
              stabile og bæredygtige løsninger i hele Danmark.
            </p>
          </div>

          {/* Column 2: Fundamentløsninger */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-orange-400 mb-5">Fundamentløsninger</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/skruefundering" className="text-slate-400 hover:text-white transition-colors">
                  Skruefundering
                </Link>
              </li>
              <li>
                <Link to="/jordanker" className="text-slate-400 hover:text-white transition-colors">
                  Jordanker
                </Link>
              </li>
              <li>
                <Link to="/groundplug" className="text-slate-400 hover:text-white transition-colors">
                  GroundPlug
                </Link>
              </li>
              <li>
                <Link to="/projekter" className="text-slate-400 hover:text-white transition-colors">
                  Referencer & Projekter
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Skruer & Produkter */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-orange-400 mb-5">Skruer & Produkter</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/skruer" className="text-slate-400 hover:text-white transition-colors">
                  Alle skruer & specifikationer
                </Link>
              </li>
              <li>
                <Link to="/terrasseskruer" className="text-slate-400 hover:text-white transition-colors">
                  Terrasseskruer
                </Link>
              </li>
              <li>
                <Link to="/jordskruer" className="text-slate-400 hover:text-white transition-colors">
                  Jordskruer
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-slate-400 hover:text-white transition-colors">
                  Om CM Skruefundament
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-orange-400 mb-5">Kontakt os</h3>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li>
                <p className="text-white font-medium">CM Skruefundament ApS</p>
                <p>Skolevænget 14</p>
                <p>8700 Horsens</p>
              </li>
              <li>
                <p>Telefon: <a href="tel:+4526796139" className="hover:text-white transition-colors">26 79 61 39</a></p>
                <p>Email: <a href="mailto:cs@cmskruefundament.dk" className="hover:text-white transition-colors">cs@cmskruefundament.dk</a></p>
              </li>
              <li>
                <p>CVR nr. 46330080</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} CM Skruefundament ApS. Alle rettigheder forbeholdes.
          </p>
          <p className="text-slate-500 text-sm">
            Design & Udvikling af Auxo
          </p>
        </div>
      </div>
    </footer>
  );
}
